import { AppActionType } from './types';
import { Dispatch } from 'redux';

export const selectResource = selectedResource => async (dispatch: Dispatch, getState) => {
  const {
    app: { resource }
  } = getState();

  dispatch({
    type: AppActionType.SELECT_RESOURCE,
    data: selectedResource
  });

  return {
    type: AppActionType.SELECT_RESOURCE,
    data: resource.selectedResource
  };
};

export const setResourceFilters = (searchText, tagIds) => {
  return {
    type: AppActionType.SET_RESOURCE_FILTERS,
    data: { searchText, tagIds }
  };
};

export const toggleResourcePlayerVisibility = () => ({
  type: AppActionType.TOGGLE_RESOURCE_PLAYER_VISIBILITY
});

export const selectCharacter = selectedCharacter => ({
  type: AppActionType.SELECT_CHARACTER,
  data: selectedCharacter
});
export const fetchCharactersRequest = () => ({
  type: AppActionType.FETCH_CHARACTERS
});
export const setAppId = app => ({
  type: AppActionType.SET_APP_ID,
  data: app
});

export const changeAppLocale = locale => ({
  type: AppActionType.CHANGE_APP_LOCALE,
  data: locale
});

// TODO provider for loading screen?
export const toggleAppLoadingScreenVisibility = () => ({
  type: 'APP.TOGGLE_APP_LOADING_SCREEN_VISIBILITY'
});

export const toggleTag = (tag: any) => ({
  type: AppActionType.APP_TOGGLE_TAG,
  tag
});

export const updateAppCounter = (operationType: string) => ({
  type: AppActionType.UPDATE_COUNTER,
  operationType
});

export const clearResourceFilters = () => ({
  type: AppActionType.APP_CLEAR_RESOURCE_FILTERS
});

export const setCurrentWorkbook = currentWorkbook => {
  return {
    type: AppActionType.CURRENT_WORKBOOK,
    currentWorkbook
  };
};

export const selectClassroom = (classroomId: number) => ({
  type: AppActionType.SELECT_CLASSROOM,
  data: { classroomId }
});

export const resetSelectedClassroom = () => ({
  type: AppActionType.SELECT_CLASSROOM,
  data: { classroomId: '' }
});
